import { createContext } from "react";

const accessContext = createContext();

export default accessContext;